module.exports = __webpack_public_path__ + "img/10_NSC_Anim_iPad_L.463064cc.jpg";